import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useMutationConfig } from '../../../../../hooks/use-mutation-config.js';
import { CREATE_APPLE_PAY_SESSION } from '../../../../../operations/mutations/create-apple-pay-session.js';
import { CheckoutErrorsMapping } from '../../../../../mappers/errors-mapping.js';

const useCreateApplePaySession = ({ onError , onCompleted ,  } = {})=>{
    var ref5, ref1, ref2, ref3;
    const [session1, setSession] = React__default.useState(null);
    const { mutationOptions  } = useMutationConfig({
        onError,
        onCompleted
    });
    const [mutationCallback, mutation] = useMutation(CREATE_APPLE_PAY_SESSION, mutationOptions);
    React__default.useEffect(()=>{
        var ref, ref4;
        const merchantSessionData = mutation === null || mutation === void 0 ? void 0 : (ref = mutation.data) === null || ref === void 0 ? void 0 : (ref4 = ref.createApplePaySession) === null || ref4 === void 0 ? void 0 : ref4.data;
        if (session1 && merchantSessionData) {
            const decodedMerchantSession = atob(merchantSessionData);
            const decodedAndParsedMerchantSession = JSON.parse(decodedMerchantSession);
            try {
                session1.completeMerchantValidation(decodedAndParsedMerchantSession);
            } catch (e) {
                // Swallow InvalidAccessError
                if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                    console.error(e);
                    toast.failed(CheckoutErrorsMapping.SomethingWentWrong);
                    throw e;
                }
            }
        }
    }, [
        session1,
        mutation === null || mutation === void 0 ? void 0 : (ref5 = mutation.data) === null || ref5 === void 0 ? void 0 : (ref1 = ref5.createApplePaySession) === null || ref1 === void 0 ? void 0 : ref1.data,
        mutation === null || mutation === void 0 ? void 0 : (ref2 = mutation.data) === null || ref2 === void 0 ? void 0 : ref2.createApplePaySession,
        mutation === null || mutation === void 0 ? void 0 : mutation.data, 
    ]);
    // The domainName should be always determined likes this. Therefore exposing it as a variable is unnecessary.
    const domainName = typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.hostname);
    const createApplePaySession = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(session) {
            setSession(session);
            yield mutationCallback({
                variables: {
                    applePaySessionInput: {
                        domainName
                    }
                }
            });
        });
        return function(session) {
            return _ref.apply(this, arguments);
        };
    }(), [
        domainName,
        mutationCallback
    ]);
    return {
        createApplePaySession,
        isLoading: mutation.loading,
        updateError: mutation.error
    };
};

export { useCreateApplePaySession };
//# sourceMappingURL=use-create-apple-pay-session.js.map
